import { useEffect } from "react";
import Button from "../../Components/Button/Button";

export default function ConfirmManualApproval(props) {
  useEffect(() => {
    if (props.selectedEmployee === null) {
      props.navigate("/");
    }
    // eslint-disable-next-line
  }, [props.selectedEmployee]);

  return (
    <div className="inherit-parent-height inherit-parent-width padding-large display-flex flex-direction-column flex-justify-content-space-between">
      <div
        style={{ height: "calc(100% - 68px)" }}
        className=" display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
      >
        <div className="font-size-medium  text-align-center ">
          CONFIRM MANUAL APPROVAL
        </div>
        <div className="font-size-small text-align-center padding-top-small ">
          Please verify the employee details before submission
        </div>

        <div className=" padding-top-larger">
          <div
            style={{
              width: "156px",
              height: "182px",
              border: "solid 2px #2965DD",
              borderRadius: "4px"
            }}
          >
            {props.faceComparisonData?.fileUrl || props.capturedPhoto ? (
              <img
                style={{
                  objectFit: "cover"
                }}
                className="inherit-parent-height inherit-parent-width"
                src={props.faceComparisonData?.fileUrl || props.capturedPhoto}
                alt="capturedImage"
              />
            ) : (
              <div className="inherit-parent-width inherit-parent-height">
                <div className="shimmer padding-larger inherit-parent-width inherit-parent-height" />
              </div>
            )}
          </div>
        </div>

        <div className=" padding-top-larger text-align-center font-size-medium">
          <span className=" "> {props.selectedEmployee?.phoneNumber} </span>,{" "}
          {props.selectedEmployee?.name}
        </div>
      </div>

      <div className=" display-flex flex-justify-content-space-between">
        <Button
          data-cy="confirm-button"
          className="margin-right-small"
          type="button"
          text="Confirm"
          boxShadow={false}
          loading={props.loading}
          onClick={() => {
            props.confirmOnClick(
              props.type ? true : false,
              props.faceComparisonData?.documentId || props.capturedId
            );
          }}
        />

        <Button
          data-cy="cancel-button"
          className="margin-left-small"
          variant="secondary"
          type="button"
          text="Cancel"
          boxShadow={false}
          loading={props.loading}
          onClick={() => {
            props.onCancelClick();
          }}
        />
      </div>
    </div>
  );
}
